/**
 * For a complete list of ZAPI errors
 *
 * @see https://developer.zattoo.com/display/ZAPI/2.1.4+-+Error+Codes
 */

export const UNSPECIFIED = 1;

/**
 * Improper protocol (not https).
 */
export const IMPROPER_PROTOCOL = 2;

/**
 * Session required: A valid session is required.
 */
export const SESSION_REQUIRED = 3;

/**
 * Login required: A valid login session is required.
 */
export const LOGIN_REQUIRED = 4;

/**
 * Watch required: You must be watching a channel.
 */
export const WATCH_REQUIRED = 5;

/**
 * Recording required: The User must have access to Recording.
 */
export const RECORDING_REQUIRED = 6;

/**
 * Invalid Recording: The User does not have access to this Recording.
 */
export const RECORDING_INVALID = 7;

/**
 * Temporarily disabled: This method is temporarily disabled, for instance due
 * to a Zattoo maintenance.
 */
export const DISABLED_METHOD = 8;

/**
 * App version is too old.
 */
export const OLD_APP_VERSION = 9;

/**
 * Unsupported content type.
 */
export const INVALID_CONTENT_TYPE = 10;

/**
 * Could not start Watch, error at streaming server.
 */
export const STREAMING_SERVER_ERROR = 11;

/**
 * Locale not supported - user has no channel access.
 */
export const LOCALE_INVALID = 12;

/**
 * Selective recall rights required.
 */
export const REQUIRED_SELECTIVE_RECALL = 14;

/**
 * Local Recording required: The User must have access to Local Recording.
 */
export const REQUIRED_LOCAL_RECORDING = 15;

/**
 * Series Recording required: The User must have access to Series Recording.
 */
export const REQUIRED_SERIES_RECORDING = 17;

/**
 * You have been logged out because your Account was deleted externally.
 */
export const DELETED_ACCOUNT = 18;

/**
 *  Your app is no longer supported by ZAPI.
 */
export const UNSUPPORTED_APP = 19;

/**
 *  Invalid pagination param - page or per is not an integer
 */
export const INVALID_PAGINATION_PARAMETER = 24;

/**
 *  Invalid language code - only two-letter language codes are accepted
 */
export const INVALID_TNC_LANGUAGE = 26;

/**
 * Missing App ID.
 */
export const APP_ID_MISSING = 101;

/**
 * Invalid App ID.
 */
export const APP_ID_INVALID = 102;

/**
 * Missing UUID.
 */
export const UUID_MISSING = 103;

/**
 * Missing lang.
 */
export const LANG_MISSING = 104;

/**
 * Invalid lang.
 */
export const LANG_INVALID = 105;

/**
 * Invalid format.
 */
export const FORMAT_INVALID = 106;

/**
 * Invalid live_thumbs string.
 */
export const LIVE_THUMBS_INVALID = 107;

/**
 * Invalid program_thumbs string.
 */
export const PROGRAM_THUMBS_INVALID = 108;

/**
 * Absent partner.
 */
export const PARTNER_MISSING = 109;

/**
 * Invalid partner.
 */
export const PARTNER_INVALID = 110;

/**
 * Invalid Session Token.
 */
export const SESSION_TOKEN_INVALID = 111;

/**
 * Absent app_version.
 */
export const APP_VERSION_MISSING = 115;

/**
 * Bad app_version.
 */
export const APP_VERSION_INVALID = 116;

/**
 * Absent referrer_id
 */
export const ABSENT_REFERRER_ID = 119;

/**
 * Missing or invalid login/password.
 */
export const CREDENTIALS_INVALID = 200;

/**
 * Missing or invalid credentials or account information, with details.
 */
export const CREDENTIALS_MISSING_OR_INVALID = 203;

/**
 * Invalid Account Token.
 */
export const ACCOUNT_TOKEN_INVALID = 206;

/**
 * Invalid SSO.
 */
export const SSO_INVALID = 207;

/**
 * Error at external SSO provider.
 */
export const SSO_PROVIDER_ERROR = 209;

/**
 * ZUYA server failed, reason unknown. Can happen on almost any call if a ZUYA Account call occurs.
 */
export const UNKNOWN_ZUYA_SERVER_FAILURE = 213;

/**
 * ZAPI stops accepting any login tries after some (around 10) failed login attempts
 */
export const TOO_MANY_FAILED_LOGIN_ATTEMPTS = 214;

/**
 * Absent status.
 */
export const STATUS_MISSING = 221;

/**
 * Absent "country_code".
 */
export const COUNTRY_CODE_MISSING = 222;

/**
 * Invalid "country_code".
 */
export const COUNTRY_CODE_INVALID = 223;

/**
 * Cannot take this action due to having an active Subscription, user may contact
 * Zattoo Support for assistance.
 */
export const ACCOUNT_DELETION_IMPOSSIBLE = 241;

/**
 * Missing PIN.
 */
export const PIN_MISSING = 261;

/**
 * Invalid PIN.
 */
export const PIN_INVALID = 262;

/**
 * Invalid PIN config. Either a a PIN is required, but not set or more then one
 * PIN is active.
 */
export const PIN_SETUP_REQUIRED = 263;

/**
 * PIN locked. The user entered a wrong PIN too often. Retry will be blocked for some time.
 */
export const PIN_LOCKED = 264;

/**
 * Missing Shop ID.
 */
export const SHOP_ID_MISSING = 300;

/**
 * Invalid Shop ID.
 */
export const SHOP_ID_INVALID = 301;

/**
 * Error code indicating that a transaction failed because of a duplicate receipt.
 */
export const DUPLICATE_RECEIPT = 324;

/**
 * market must be a string
 */
export const INVALID_TNC_MARKET = 383;

/**
 * Missing tnc_id
 */
export const ABSENT_TNC_ID_EXCEPTION = 384;

/**
 * tnc_id must be an integer
 */
export const INVALID_TNC_ID_EXCEPTION = 385;

/**
 * User must accept newer Terms & Conditions
 */
export const NEWER_TNC_EXCEPTION = 386;

/**
 * No stream type provided.
 */
export const STREAM_TYPE_MISSING = 400;

/**
 * Invalid stream type.
 */
export const STREAM_TYPE_INVALID = 401;

/**
 * Invalid padding.
 */
export const PADDING_INVALID = 404;

/**
 * Invalid timeshift, must be a positive integer.
 */
export const TIMESHIFT_INVALID = 408;

/**
 * Warning: Starting series recording would add a large number of recordings.
 * See extra field "num_to_record" for the number. Repeat call with parameter
 * "series_force=True" to override.
 */
export const SERIES_RECORDING_WARNING = 409;

/**
 * Can't watch this recorded content yet
 */
export const RECORDING_IS_NOT_READY_YET = 411;

/**
 * Missing cid.
 */
export const CID_MISSING = 420;

/**
 * Invalid cid.
 */
export const CID_INVALID = 421;

/**
 * Missing Program ID.
 */
export const PID_MISSING = 423;

/**
 * Invalid Program ID.
 */
export const PID_INVALID = 424;

/**
 * Missing Recording ID or "recording_ids".
 */
export const RECORDING_ID_MISSING = 425;

/**
 * Invalid Recording ID or invalidly-formatted "recording_ids".
 */
export const RECORDING_ID_INVALID = 426;

/**
 * Playlist too large, can't add recording.
 */
export const PLAYLIST_FULL = 428;

/**
 * User is not authorized.
 */
export const SUBSCRIPTION_REQUIRED = 422;

/**
 * No query given
 */
export const QUERY_MISSING = 443;

/**
 * Series not found
 */
export const SERIES_NOT_FOUND = 450;

/**
 * Missing teasable_id
 */
export const TEASABLE_ID_MISSING = 540;

/**
 * Missing teasable_type
 */
export const TEASABLE_TYPE_MISSING = 541;

/**
 * Invalid id (teaser | movie | series) - raised if the id is not an integer
 */
export const INVALID_VOD_CONTENT_ID = 542;

/**
 * Invalid Teasable Type - raised if the type is unknown
 */
export const INVALID_VOD_CONTENT_TYPE = 543;

/**
 * Movie/Series not found - movie/series does either not exist or is not available for current user
 */
export const VOD_CONTENT_NOT_FOUND = 544;

/**
 * The user rented / ordered this content already
 */
export const VOD_CONTENT_ALREADY_ORDERED = 582;

/**
 * Order not found - user either did not order this content or the order is expired
 */
export const VOD_ORDER_NOT_FOUND = 583;

/**
 *  The user is blocked from purchasing items due to billing issues or an account penalty
 */
export const VOD_ORDER_BLOCKED = 587;

/**
 * The user is blocked from purchasing items due to suspicious account behavior,
 * eg because many contents have been bought in short term.
 */
export const VOD_ORDER_LIMIT_REACHED = 588;

/**
 * The user has chosen to order a VOD content
 * but the tenant wants to display a confirmation box before the actual purchase.
 */
export const VOD_ORDER_CONFIRMATION_EXCEPTION = 589;

/**
 * The VOD campaign is expired.
 */
export const CAMPAIGN_EXPIRED_EXCEPTION = 595;

/**
 * There is an active campaign for the term.
 */
export const ACTIVE_CAMPAIGN_EXCEPTION = 596;

/**
 * The campaign_token does not match for the currently active campaign.
 */
export const WRONG_CAMPAIGN_TOKEN_EXCEPTION = 597;

/**
 * Absent device_id.
 */
export const ABSENT_DEVICE_ID = 600;

/**
 * Absent minutes_left.
 */
export const ABSENT_MINUTES_LEFT = 601;

/**
 *  Invalid minutes_left, must be a nonnegative integer.
 */
export const INVALID_MINUTES_LEFT = 602;

/**
 * Absent recorder_id.
 */
export const ABSENT_RECORDER_ID = 603;

/**
 * Invalid recorder_id, unknown or does not belong to the logged-in user.
 */
export const INAVLID_RECORDER_ID = 604;

/**
 * Absent recording_id.
 */
export const ABSENT_RECORDING_ID = 605;

/**
 * Invalid recording_id, unknown or does not belong to the logged-in user.
 */
export const INVALID_RECORDING_ID = 606;

/**
 * Absent status_code.
 */
export const ABSENT_STATUS_CODE = 607;

/**
 * Invalid status_code, must be a nonnegative integer.
 */
export const INVALID_STATUS_CODE = 608;

/**
 * Absent serial_number.
 */
export const ABSENT_SERIAL_NUMBER = 609;

/**
 * Invalid primary storage device.
 */
export const INVALID_PRIMARY_STORAGE = 610;

/**
 * Cannot schedule local recording; would result in too many concurrent recordings
 * at the some point in time.
 */
export const LOCAL_RECORDINGS_CONCURRENT_READINGS = 620;

/**
 * Cannot schedule local recording; local recorder is not ready and scheduling
 * was not forced.
 */
export const LOCAL_RECORDER_NOT_READY = 621;

/**
 * Cannot schedule local recording; local recording has already been scheduled.
 */
export const LOCAL_RECORDING_ALREAY_SCHEDULED = 622;

/**
 * Cannot stop/cancel/complete local recording; recording was stopped or end is
 * otherwise too late.
 */
export const LOCAL_RECORDING_STOPPED = 640;

/**
 * Cannot stop/cancel/complete local recording; recording was canceled.
 */
export const LOCAL_RECORDING_CANCELED = 641;

/**
 * Cannot stop/cancel/complete local recording; recording was completed.
 */
export const LOCAL_RECORDING_COMPLETED = 642;

export const UNKNOWN = 9000;
export const NETWORK_FAILURE = 9002;
export const INVALID_JSON = 9004;
